import { restApiMP } from "@plannel/services/utils/rest-api";

/**
 * FLO 차트(BOM 모델 플로우) 조회 서비스.
 * 특정 품목(itemCd)을 루트로 전개된 BOM/라우트/라우팅 서브그래프를 가져온다.
 * 응답: { items, resources, routes, boms, routings } (camelCase)
 */
const get = (itemCd) => {
  return restApiMP.get("/api/flo-chart", { params: { itemCd } });
};

const floChartService = {
  get,
};

export default floChartService;
